export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte I_040226.pdf",
        "type": "pdf"
    },
]